'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = require('redux');

var _actions = require('./actions');

var _util = require('./util');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var queries = function queries() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var type = action.type,
      payload = action.payload,
      meta = action.meta;


  switch (type) {
    case _actions.INIT:
      return payload.reduce(function (acc, cur) {
        return _extends({}, acc, _defineProperty({}, cur.name, {
          params: cur.params,
          handler: cur.handler,
          loading: false,
          loaded: false
        }));
      }, state);

    case _actions.UPDATE:
      return _extends({}, state, _defineProperty({}, payload.name, _extends({}, state[payload.name], {
        params: payload.params
      })));

    case _actions.PERFORM_REQUEST:
      return _extends({}, state, _defineProperty({}, meta.name, _extends({}, state[meta.name], {
        loading: true
      })));

    case _actions.PERFORM_SUCCESS:
      return _extends({}, state, _defineProperty({}, meta.name, _extends({}, state[meta.name], payload, {
        loading: false,
        loaded: true
      })));

    case _actions.PERFORM_FAILURE:
      return _extends({}, state, _defineProperty({}, meta.name, _extends({}, state[meta.name], {
        error: payload,
        results: null,
        loading: false,
        loaded: false
      })));

    default:
      return state;
  }
};

var requests = function requests() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var type = action.type,
      payload = action.payload,
      _action$meta = action.meta,
      meta = _action$meta === undefined ? {} : _action$meta;

  var key = (0, _util.serialize)(meta.name, meta.params);

  switch (type) {
    case _actions.PERFORM_REQUEST:
      return _extends({}, state, _defineProperty({}, key, _extends({}, state[key], {
        loading: true
      })));

    case _actions.PERFORM_SUCCESS:
      return _extends({}, state, _defineProperty({}, key, _extends({}, state[key], {
        loading: false,
        loaded: true,
        results: payload
      })));

    case _actions.PERFORM_FAILURE:
      return _extends({}, state, _defineProperty({}, key, _extends({}, state[key], {
        loading: false,
        loaded: false,
        error: payload
      })));

    default:
      return state;
  }
};

exports.default = (0, _redux.combineReducers)({
  queries: queries,
  requests: requests
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@jump/pages/lib/reducer.js
// module id = 262
// module chunks = 0